export default function PublicFooter() {
  return (
    <footer data-testid="public-footer">
      {/* Diagonal wave transition */}
      <div className="relative">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-12 lg:h-16 block" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,80 L0,30 Q360,0 720,20 Q1080,40 1440,10 L1440,80 Z" fill="#015492" />
        </svg>
      </div>

      <div className="bg-[#015492] text-white">
        <div className="max-w-7xl mx-auto px-4 py-8 lg:py-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {/* Column 1: About */}
            <div>
              <h3 className="text-base font-bold text-[#9fc521] mb-3">Power Compare</h3>
              <div className="space-y-1.5 text-sm text-white/80">
                <p>Compare your business electricity costs and find a better deal.</p>
                <p className="pt-2 text-white/60 text-xs">&copy; {new Date().getFullYear()} All rights reserved.</p>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div>
              <h3 className="text-base font-bold text-[#9fc521] mb-3">Quick Links</h3>
              <ul className="space-y-1.5">
                <li><a href="/" className="text-sm text-white/80 hover:text-[#9fc521] transition-colors">Compare Your Bill</a></li>
                <li><a href="/login" className="text-sm text-white/80 hover:text-[#9fc521] transition-colors">Staff Login</a></li>
              </ul>
            </div>

            {/* Column 3: Contact */}
            <div>
              <h3 className="text-base font-bold text-[#9fc521] mb-3">Contact</h3>
              <ul className="space-y-1.5">
                <li><a href="mailto:info@example.com" className="text-sm text-white/80 hover:text-[#9fc521] transition-colors">info@example.com</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
